import React,{useState,useEffect} from "react";
import apiFetch from "@wordpress/api-fetch";
import { __ } from "@wordpress/i18n";
import "./Passkeys.scss";
import withForm from '../../pages/withForm';

const Overview = () => {
	const [statistics, setStatistics] = useState([]);
	// Get active logins data
	useEffect(() => {
		const getAllPasskeys = async () => {
			try {
				const response = await apiFetch({
					path: '/ultimate-security/v1/get-passkeys-statistics',
					method: 'GET'
				});
				// console.log(response.data);
				setStatistics(response.data);
			} catch (error) {
				console.error(error);
			}
		};
		getAllPasskeys();
	}, []);

	return (
		<div className="ultimate-security-passkeys">
			<h2 className="pl-heading-1 mb-3 fw-bold">{__("Statistics", "ultimate-security")}</h2>
			<div className="row mb-5">
				<div className="col-md-3">
					<div className="dash-card " style={{height: "92px"}}>
						<div className="card-body p-4 d-flex align-items-center">
							<div
								className="me-3 d-flex align-items-center justify-content-center"
								style={{ width: "50px", height: "50px" }}
							>
                               <img src={ultimate_security_ajax_obj.imageUrl+'failed_logins.svg'} alt="icon" />
							</div>
							<div>
								<h2 className="pl-heading-1 mb-0 fw-bold">{statistics.users}</h2>
								<p className="text-text mb-0 small">
									{__("Users", "ultimate-security")}
								</p>
							</div>
						</div>
					</div>
				</div>

				<div className="col-md-3">
					<div className="dash-card " style={{height: "92px"}}>
						<div className="card-body p-4 d-flex align-items-center">
							<div
								className="me-3 d-flex align-items-center justify-content-center"
								style={{ width: "50px", height: "50px" }}
							>
                                <img src={ultimate_security_ajax_obj.imageUrl+'user-2.svg'} alt="icon" />
							</div>
							<div>
								<h2 className="pl-heading-1 mb-0 fw-bold">{statistics.passkeys}</h2>
								<p className="text-text mb-0 small">
									{__("Passkeys", "ultimate-security")}
								</p>
							</div>
						</div>
					</div>
				</div>

				<div className="col-md-3">
					<div className="dash-card " style={{height: "92px"}}>
						<div className="card-body p-4 d-flex align-items-center">
							<div
								className="me-3 d-flex align-items-center justify-content-center"
								style={{ width: "50px", height: "50px" }}
							>
                                <img src={ultimate_security_ajax_obj.imageUrl+'user-3.svg'} alt="icon" />
							</div>
							<div>
								<h2 className="pl-heading-1 mb-0 fw-bold">{statistics.activities}</h2>
								<p className="text-text mb-0 small">
									{__("Activities", "ultimate-security")}
								</p>
							</div>
						</div>
					</div>
				</div>

				<div className="col-md-3">
							
					<div className="dash-card " style={{height: "92px"}}>
						<div className="card-body p-4 d-flex align-items-center">
							<div
								className="me-3 d-flex align-items-center justify-content-center"
								style={{ width: "50px", height: "50px" }}
							>
                                <img src={ultimate_security_ajax_obj.imageUrl+'user-4.svg'} alt="icon" />
							</div>
							<div>
								<h2 className="pl-heading-1 mb-0 fw-bold">{statistics.challenges}</h2>
								<p className="text-text mb-0 small">
									{__("Challenges", "ultimate-security")}
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
			
			<div className="row">
				{/* Overview of Authenticators */}
				<div className="col-md-6">
					<h2 className="pl-heading-1 mb-3 fw-bold">
						{__("Overview of Authenticators", "ultimate-security")}
					</h2>
					<div className="dash-card" style={{ height: "360px" }}>
						<div className="card-body p-4 d-flex flex-column">
							<ul className="list-unstyled mb-0">
								{statistics.authenticators_log && Object.keys(statistics.authenticators_log).length > 0 ? (
									Object.entries(statistics.authenticators_log).slice(0, 5).map(([name, count], index) => (
										<li key={index} className="mb-2 d-flex justify-content-between">
											<span>{name}</span>
											<strong>{count}</strong>
										</li>
									))
								) : (
									<li className="mb-2">
										<span className="pl-heading-1 fw-bold">
											{__("No authenticators registered.", "ultimate-security")}
										</span>
									</li>
								)}
							</ul>
						</div>
					</div>
				</div>

				{/* Last Login Activity */}
				<div className="col-md-6">
					<h2 className="pl-heading-1 mb-3 fw-bold">
						{__("Last Login Activity", "ultimate-security")}
					</h2>
					<div className="dash-card" style={{ height: "360px" }}>
						<div className="card-body p-4 d-flex flex-column">
							<ul className="list-unstyled mb-0">
								{statistics.last_login && statistics.last_login.length > 0 ? (
									statistics.last_login.slice(0, 5).map((activity, index) => (
										<li key={index} className="mb-2" style={{ fontSize: "13px" }}>
											<span>{activity.description} From {activity.ip_address} At {activity.created_at}</span>
										</li>
									))
								) : (
									<li className="mb-2">
										<span className="pl-heading-1 fw-bold">
											{__("No activities.", "ultimate-security")}
										</span>
									</li>
								)}
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default withForm(Overview); 